(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    module.controller('TaskStatesFilterController', ['$rootScope', '$filter', '$scope', '$localStorage', 'TaskBroadcast', 'HelperService', TaskStatesFilterControllerFn]);

    function TaskStatesFilterControllerFn($rootScope, $filter, $scope, $localStorage, TaskBroadcast, HelperService) {
        var vm = this;

        // number of set filter
        vm.numFilters = 0;
        // array of filter
        vm.states = [];

        activate();


        // filter list
        vm.filter = function ($event, state) {

            $event.stopPropagation();

            // state change
            state.vmSelected = !state.vmSelected;
            $localStorage.dayTaskStates = vm.states;
            refresh();
        };                
        
        function refresh() {

            var selectedTaskStates = vm.states.filter(function(state) {
                return state.vmSelected === true;
            }).map(function(state) {
                return state.value;
            });

            // filter table on states selected
            vm.paginationService.data.filteredItems = vm.paginationService.data.items.filter(function(task) {
                return selectedTaskStates.indexOf(task.taskState) > -1;
            });
           
            // refresh overview
            vm.paginationService.paginate();

            // number of selected states
            vm.numFilters = 0;
            var i = 0;
            var len = vm.states.length;
            for (i = 0; i < len; i++) {
                if (vm.states[i].vmSelected) {
                    vm.numFilters++;
                }
            }
        }

        // calc numbers of tasks in states
        function calculateBadges() {
            var i = 0;
            var len = vm.states.length;

            // reset all badges first
            for (i = 0; i < len; i++) {
                vm.states[i].vmNumber = 0;
            }

            var stateCounts = vm.paginationService.data.stateCounts;

            // counts returned by the backend (over all pages), if available
            if (stateCounts) {
                for (i = 0; i < len; i++) {
                    vm.states[i].vmNumber = stateCounts[vm.states[i].name] || 0;
                }
                return;
            }

            // fallback: number of (loaded) tasks in defined states
            len = vm.paginationService.data.items.length;
            for (i = 0; i < len; i++) {
                var state = $filter('filter')(vm.states, { 'value': vm.paginationService.data.items[i].vmTaskState }, true)[0];
                if (state) {
                    state.vmNumber++;
                }
            }
        }
        
        function activate() {
            // generate task states array
            vm.states = HelperService.generateTaskStateArray(vm.isToDo, true);

            let loadFromLocalStorage = $localStorage && $localStorage.dayTaskStates;
            vm.states.forEach(function(state) { 
                let localStorageState = null;
                // load from storage
                if (loadFromLocalStorage)
                {
                    localStorageState = $filter('filter')($localStorage.dayTaskStates, { 'value': state.value }, true)[0];
                }
                if (localStorageState)
                {
                    state.vmSelected = localStorageState.vmSelected;
                }else{
                    // no localstorage setting, load default
                    if (state.value === 0 || state.value === 2) {// InProgress //FollowUpByOperator
                        state.vmSelected = true;
                    } else if (state.value === 3) { //FollowUpByRingfoon (admin)
                        state.vmSelected = $rootScope.isRingfoonAdmin;
                    }
                }
            });
            
            calculateBadges();
            refresh();
            listen();
        }

        function listen() {
            var listener = $scope.$on(TaskBroadcast.RefreshFilter, function () {
                calculateBadges();                
                refresh();
                $scope.$evalAsync();
            });

            $scope.$on("$destroy", function () {
                if (listener) {
                    listener();
                    listener = null;
                }
            });
        }      
    }
})();
